import React, { Component } from 'react'
import DataTable from './DataTable'

export default class Display extends Component {
  render() {
    return (
      <React.Fragment>
        <DataTable />
      </React.Fragment>
    )
  }
}
